import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../styles/media'
import { colors, focusShadow } from '../../../styles/theme'

const S = {}

S.Trigger = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: auto;
  max-width: 100%;
  height: 2.75rem;
  box-sizing: border-box;
  background-color: transparent;
  transition: background-color 0.2s ease;
  border: none;
  outline: none;
  font-family: inherit;
  font-size: inherit;
  text-decoration: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  
  ${focusShadow};
  padding: ${({ isTitleOnMobile }) =>
    !isTitleOnMobile ? '0.625rem' : '0.625rem 0.75rem 0.625rem 0.5rem'};

  ${media.sm`
    padding: 0.625rem 0.75rem 0.625rem 0.5rem;
  `};

  @media (hover: hover) {
    &:hover {
      background-color: ${({ themeColor }) =>
        themeColor === 'light' ? colors.alabaster : colors.shark};

      .trigger-icon,
      .trigger-title {
        color: ${({ isOpen, isActiveFilter, accentColor, themeColor }) =>
          !isOpen && isActiveFilter
            ? accentColor
              ? accentColor
              : colors.scooter
            : themeColor === 'light'
              ? colors.black
              : colors.white};
      }
    }
  }

  &:focus {
    background-color: ${({ themeColor }) =>
      themeColor === 'light' ? colors.alabaster : colors.shark};

    .trigger-icon,
    .trigger-title {
      color: ${({ isOpen, isActiveFilter, accentColor, themeColor }) =>
        !isOpen && isActiveFilter
          ? accentColor
            ? accentColor
            : colors.scooter
          : themeColor === 'light'
            ? colors.black
            : colors.white};
    }
  }

  .trigger-icon,
  .trigger-title {
    transition: color 0.2s ease;
  }

  .trigger-icon {
    fill: currentColor;
    width: 1.5rem;
    height: 1.5rem;
    color: ${({ themeColor }) =>
      themeColor === 'light'
        ? colors.scarpaFlow
        : themeColor === 'custom'
          ? 'inherit'
          : colors.silverChalice};
  }

  .trigger-title {
    font-size: 0.875rem;
    font-weight: 800;
    text-transform: uppercase;
    line-height: 1.29;
    color: ${({ themeColor }) =>
      themeColor === 'light'
        ? colors.scarpaFlow
        : themeColor === 'custom'
          ? 'inherit'
          : colors.silverChalice};
    margin-inline-start: 0.5rem;

    ${({ isTitleOnMobile }) =>
      !isTitleOnMobile &&
      css`
        display: none;

        ${media.sm`
          display: block;
        `};
      `};
  }

  ${({ isOpen, themeColor }) =>
    isOpen &&
    css`
      background-color: ${themeColor === 'light'
        ? colors.alabaster
        : colors.shark};

      .trigger-icon,
      .trigger-title {
        color: ${themeColor === 'light' ? colors.black : colors.white};
      }
    `};

  ${({ isActiveFilter, isOpen, accentColor }) =>
    isActiveFilter &&
    css`
      .trigger-icon,
      .trigger-title {
        color: ${!isOpen && (accentColor ? accentColor : colors.scooter)};
      }
    `};
`
export default S
